module.exports = __webpack_public_path__ + "img/shanc.1ad7afe5.svg";